import * as _ from 'lodash';
import {Component} from '@angular/core';

@Component({
    template: ''
})
export abstract class AcFilterType {

    abstract filterName: string;
    filterTitle = '';
    hasChanged;
    createItem;
    disableRemove;
    getCustomContent;
    getCustomContentTemplate;
    getTitleByField: Function;
    fieldNameMapper;
    initializeState;
    notEditable = false;
    onRemoveItem;
    showPinnable = false;
    pinnable = false;
    pinned = false;
    expanded;
    pinningDisabled = false;
    first: boolean;
    selectionFields: FilterTypeSelectionFields;
    checkboxGroups: FilterTypeCheckboxGroups;
    lastItem;
    lastItem_default;
    abstract setStateForItem;

    isValid: Function = () => true;

    onExpand = () => {};

    ngOnInit(){
        if(this.lastItem_default){
            this.lastItem = _.cloneDeep(this.lastItem_default);
        }
    }
}

export interface FilterTypeCheckboxGroups {
    [key: string]: {
        checkboxGroupId: string;
        value?: any;
        map?: any;
        textClass?: any;
        label?: string;
        iconType?: string;
        showIcon?: boolean;
        iconClasses?: string;
        options?: Array<{
            text: string;
            name: string;
        }>;
    };
}

export interface FilterTypeSelectionFields {
    [key: string]: {
        addCustomTags?: boolean;
        isAuthorized?: boolean;
        isVisible?: boolean;
        listName?: string;
        list?: any;
        options?: any;
        prefixList?: any;
    };
}
